import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
// @mui
import { Autocomplete } from '@react-google-maps/api';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Checkbox,
  Fade,
  Icon,
  InputAdornment,
  MenuItem,
  Portal,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { Box, fontSize, width } from '@mui/system';
import { useSnackbar } from 'notistack';
// theme
import { useVisibility } from 'src/context/visibility-context';
//
import Iconify from 'src/components/iconify';
import { useLocationFields } from 'src/context/location-context';
import { useJobsData } from 'src/context/job-context';
import axios, { endpoints } from 'src/utils/axios';
import { StyledMenu } from 'src/layouts/main/nav/desktop/styles';
import { useBoolean } from 'src/hooks/use-boolean';
import './style.css';
import { useResponsive } from 'src/hooks/use-responsive';
import { usePositionData } from 'src/context/current-location-context';
import Logo from '../logo';
import CustomPopover from '../custom-popover';
import { DatePicker } from '@mui/x-date-pickers';
import { fDate2 } from 'src/utils/format-time';
import ToggleSwitch from './ToggleSwitch';
import ToggleSwitchFilterJobs from './ToggleSwitchFilterJobs';
import { useGetUsers } from 'src/api/user';
import { useGetOffices } from 'src/api/office';
import { IconButton } from '@mui/material';
// ----------------------------------------------------------------------

export default function HeaderFilters({ IsHeatMap, setIsHeatMap, myJobs, setMyJobs }) {
  const { toggleVisibility } = useVisibility();
  const { enqueueSnackbar } = useSnackbar();
  const nav = useBoolean();
  const popover = useBoolean();
  const smDown = useResponsive('down', 'sm');
  const { updatePositionData } = usePositionData();
  const buttonRef = useRef();
  const { updateJobsData, JobsData } = useJobsData();
  const { locationData, resetLocationData, updateLocationData } = useLocationFields();
  const [positions, setPositions] = useState({});
  const [radius, setRadius] = useState('Select Distance');
  const [userName, setUserName] = useState('Select User Name');
  const [loading, setLoading] = useState(false);
  const [formattedAddress, setFormattedAddress] = useState('');
  const [autocompleteValue, setAutocompleteValue] = useState(null);
  const [resetLoading, setresetLoading] = useState(false);
  const [min, setMin] = useState('');
  const [max, setMax] = useState('');
  const [rangeType, setRangeType] = useState('Select Date Range');
  const [officeType, setOfficeType] = useState('Select Office Name');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { users, usersLoading } = useGetUsers();

  const salesRepsInCompany = users.filter((user) => user?.role?.name === 'Sales Representative');
  const { offices, officesLoading } = useGetOffices();
  // useEffect(() => {
  //   if (JobsData && JobsData.jobs) {
  //     let jobs = JobsData.jobs.filter((item) => item?.userName == userName);
  //     updateJobsData({
  //       jobs: jobs,
  //     });
  //     console.log(JobsData?.jobs, 'job data issssssssssssssssssssssssss')
  //   }
  // }, [userName]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const pacContainer = document.querySelector(".pac-container");
  //     if (pacContainer) {
  //       pacContainer.style.zIndex = "20000"; // Adjust as needed
  //     }
  //   }, 100); // Keep checking until pac-container is found

  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const applyZIndex = () => {
      const pacContainers = document.querySelectorAll('.pac-container');
      pacContainers.forEach(container => {
        container.style.zIndex = '20000';
      });
    };

    applyZIndex();

    // Set up an interval to check for containers since they're created dynamically
    const intervalId = setInterval(() => {
      const containers = document.querySelectorAll('.pac-container');
      if (containers.length > 0) {
        applyZIndex();
      }
    }, 100);

    const handleFocus = () => {
      setTimeout(applyZIndex, 100);
    };

    const desktopInput = document.querySelector('.mainContainerAutoComplete input');
    const mobileInput = document.querySelector('.mainContainerAutoComplete2 input');

    if (desktopInput) {
      desktopInput.addEventListener('focus', handleFocus);
    }

    if (mobileInput) {
      mobileInput.addEventListener('focus', handleFocus);
    }

    // Also handle window resize which might trigger mobile/desktop view changes
    const handleResize = () => {
      setTimeout(applyZIndex, 200);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearInterval(intervalId);

      if (desktopInput) {
        desktopInput.removeEventListener('focus', handleFocus);
      }

      if (mobileInput) {
        mobileInput.removeEventListener('focus', handleFocus);
      }

      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const onLoadAutocomplete = (autocomplete) => {
    setAutocompleteValue(autocomplete);
  };
  useEffect(() => {
    if (locationData.lat) {
      setRadius(locationData.radius || 'Select Distance');
      setPositions({ lat: locationData.lat, lng: locationData.lng });
      setFormattedAddress(locationData.formattedAddress);
    }
  }, [locationData]);
  const menuRef = useRef(null);
  useEffect(() => {
    const handleResize = () => popover.onFalse(); // Close on resize

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          console.log('Latitude:', latitude, 'Longitude:', longitude);

          updatePositionData({
            currentPosition: [latitude, longitude],
          });
          const geocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

          try {
            const response = await fetch(geocodingUrl);
            const data = await response.json();

            if (data.status === 'OK') {
            } else {
            }
          } catch (error) {}
        },
        (error) => {
          console.error('Error getting location:', error.message);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }, []);

  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (
  //       (popover.value || nav.value) &&
  //       menuRef.current &&
  //       !menuRef.current.contains(event.target) &&
  //       buttonRef.current &&
  //       !buttonRef.current.contains(event.target) &&
  //       !event.target.closest('.username-dropdown') // Prevent closing when clicking inside dropdown
  //     ) {
  //       popover.onFalse();
  //       nav.onFalse();
  //     }
  //   }

  //   // Add event listener when popover is open
  //   if (popover.value || nav.value) {
  //     document.addEventListener('mousedown', handleClickOutside);
  //   }

  //   // Cleanup the event listener
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [popover.value, nav.value]);

  const onPlaceChanged = () => {
    if (autocompleteValue !== null) {
      const place = autocompleteValue.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const newDropOffPosition = { lat, lng };
        setPositions(newDropOffPosition);
        setFormattedAddress(place.formatted_address);
      }
    }
  };

  const handleSubmit = async (min, max, reset) => {
    if (min && max) {
      if (Number(min) > Number(max)) {
        return enqueueSnackbar('Min price must be less than max price', { variant: 'error' });
      }
    }
    if (!reset) {
      updateLocationData({
        lat: positions.lat,
        lng: positions.lng,
        radius: radius == 'Select Distance' ? null : radius,
        formattedAddress,
      });
    }
    const apiData = {};
    if (radius != 'Select Distance') {
      apiData.radiusInMiles = radius;
    }
    if (positions?.lng !== undefined && positions?.lat !== undefined) {
      apiData.coordinates = [positions.lng, positions.lat];
    }
    if (min || max !== '') {
      apiData.price = {};
      if (min) {
        apiData.price.min = Number(min);
      }
      if (max !== '') {
        apiData.price.max = Number(max);
      }
    }

    if (rangeType != 'Select Date Range') {
      apiData.dateFilter = rangeType;
    }

    if (rangeType == 'custom' && !reset) {
      if (startDate == null) {
        return enqueueSnackbar('Please select an start date', { variant: 'error' });
      }
      if (endDate == null) {
        return enqueueSnackbar('Please select an end date', { variant: 'error' });
      }

      const start = startDate;
      const end = endDate;

      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      if (start > end) {
        return enqueueSnackbar('The start date cannot be later than the end date', {
          variant: 'error',
        });
      }

      apiData.dateRange = {
        start: startDate,
        end: endDate,
      };
    }
    if (userName != 'Select User Name') {
      apiData.userName = userName || '';
    }
    if (officeType != 'Select Office Name') {
      apiData.officeName = officeType;
    }
    if (!reset) {
      setLoading(true);
    }

    try {
      const { data } = await axios.post(endpoints.getJobs.list, reset ? {} : apiData);

      if (data?.data?.length > 0) {
        updateJobsData({ jobs: data.data });
        popover.onFalse();
        nav.onFalse();
        enqueueSnackbar('Jobs Found', { variant: 'success' });
      } else {
        updateJobsData({ jobs: [] });
        console.log('this runs', data.data);
        popover.onFalse();
        nav.onFalse();
        enqueueSnackbar('No Job Found', { variant: 'error' });
      }

      if (reset) {
        setUserName('Select User Name');
        setOfficeType('Select Office Name');
      }

      setLoading(false);
      setresetLoading(false);

      return data;
    } catch (error) {
      console.error('Error creating compay:', error);
      setLoading(false);
      setresetLoading(false);

      throw error;
    }
  };

  const noJobFound = async () => {
    const apiData = {};

    try {
      const { data } = await axios.post(endpoints.getJobs.list, apiData);
      if (data.data.length > 0) {
        updateJobsData({
          jobs: data.data,
        });
        nav.onFalse();
      }
      return data;
    } catch (error) {
      console.error('Error creating compay:', error);

      throw error;
    }
  };

  // const CustomSelectIcon = () => {
  //   if (userName !== 'Select User Name') return <Iconify icon='mdi-close' sx={{mr: 1}}/>;
  //   return <Iconify icon='mdi-keyboard-arrow-down' sx={{mr: 1}}/>
  // };
  const logoPath = '/logo/nav-logo.png';
  const logoPath2 = '/logo/nav-logo-2.png';
  return (
    <>
      <Box
        position="relative"
        sx={{
          margin: '0px 10px',
          textAlign: 'center',
          justifyContent: 'start',
          // paddingLeft: '50px',
          width: '100%',
          flexWrap: { xs: 'wrap', md: 'wrap', lg: 'nowrap' },
          '@media (max-width: 1200px)': {
            // Media query for small screens
            justifyContent: 'end', // Adjust width on small screens
            paddingRight: '10px',
          },
        }}
        gap={3}
        display="flex"
      >
        {/* <Box
          sx={{
            position: 'absolute',
            left: '-20px',
            top: '13px',
            display: 'block',
            '@media (max-width: 1600px)': {
              display: 'none',
            },
            '@media (max-width: 1200px)': {
              display: 'block',
            },
            '@media (max-width: 600px)': {
              top: '5px',
            },
          }}
        >
          <Logo sx={{ height: '30px', width: '150px' }} />
          <img className="nav-logo" height={30} src={logoPath} alt="logo" />
        </Box> */}
        <Box
          sx={{
            position: 'absolute',
            left: '-20px',
            top: '13px',
            display: 'none',
            '@media (max-width: 1600px)': {
              display: 'block',
            },
            '@media (max-width: 1200px)': {
              display: 'none',
            },
            '@media (max-width: 1350px)': {
              left: '-30px', // Adjust width on small screens
            },
          }}
        >
          {/* <img className="nav-logo" height={30} src={logoPath2} alt="logo" /> */}
          {/* <Logo sx={{ height: '30px', width: '150px' }} /> */}
        </Box>
        <Box
          sx={{
            display: 'flex',
            position: 'relative',
            '@media (max-width: 1200px)': {
              // Media query for small screens
              display: 'none', // Adjust width on small screens
            },
          }}
        >
          <Box
            sx={{
              background: '#212b36',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderTopLeftRadius: '10px',
              borderBottomLeftRadius: '10px',
              height: '53px',
              width: '60px',
            }}
          >
            <Iconify style={{ color: 'white' }} icon="gis:location-poi" />
          </Box>
          <Autocomplete
            className="mainContainerAutoComplete"
            onLoad={onLoadAutocomplete}
            onPlaceChanged={onPlaceChanged}
            options={{
              types: ['address'],
              componentRestrictions: { country: 'US' },
            }}
          >
            <TextField
              value={formattedAddress}
              onChange={(e) => setFormattedAddress(e.target.value)}
              placeholder="Enter a location"
              sx={{
                paddingRight: '15px',
                height: '100%',
                width: '450px',
                background: 'white',
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px',
                borderTopLeftRadius: '0px !important',
                borderBottomLeftRadius: '0px !important',
                '& .MuiOutlinedInput-root': {
                  paddingRight: '30px',
                  '& fieldset': {
                    borderTopLeftRadius: '0px !important',
                    borderBottomLeftRadius: '0px !important',
                  },
                  '&:hover fieldset': { borderTopLeftRadius: '0px !important' },
                  '&.Mui-focused fieldset': { borderBottomLeftRadius: '0px !important' },
                },
                '@media (max-width: 1750px)': {
                  // Media query for small screens
                  width: '270px', // Adjust width on small screens
                },
                '@media (max-width: 1650px)': {
                  width: '200px', // Adjust width on small screens
                },
                '@media (max-width: 1350px)': {
                  width: '150px', // Adjust width on small screens
                },
                // '@media (max-width: 1500px)': {
                //   // Media query for small screens
                //   width: '220px', // Adjust width on small screens
                // },
              }}
            />
          </Autocomplete>
          {formattedAddress != '' && (
            <Iconify
              onClick={() => {
                setFormattedAddress('');
              }}
              icon="material-symbols:close"
              style={{
                position: 'absolute',
                top: '16px',
                right: '20px',
                color: '#9ea392',
                cursor: 'pointer',
              }}
            />
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            '@media (max-width: 1200px)': {
              // Media query for small screens
              display: 'none', // Adjust width on small screens
            },
          }}
        >
          <Box
            sx={{
              background: '#212b36',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              borderTopLeftRadius: '10px',
              borderBottomLeftRadius: '10px',
              width: '60px',
              height: '55px',
              color: 'white',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.03 6.03 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8"
              />
            </svg>
          </Box>
          <TextField
            select
            fullWidth
            value={radius}
            className={radius == 'Select Distance' ? 'select-placeholder' : ''}
            onChange={(e) => setRadius(e.target.value)}
            sx={{
              width: '130px',
              borderTopRightRadius: '10px',
              borderBottomRightRadius: '10px',
              background: 'white',
              borderTopLeftRadius: '0px !important',
              borderBottomLeftRadius: '0px !important',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderTopLeftRadius: '0px !important',
                  borderBottomLeftRadius: '0px !important',
                },
                '&.Mui-focused fieldset': {
                  borderTopLeftRadius: '0px !important',
                  borderBottomLeftRadius: '0px !important',
                },
              },
              '@media (max-width: 1500px)': {
                // Media query for small screens
                width: '100px', // Adjust width on small screens
              },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    maxHeight: 220,
                    textTransform: 'capitalize',
                  },
                },
              },
              sx: { textTransform: 'capitalize' },
            }}
          >
            <MenuItem value="Select Distance" disabled>
              Select Distance
            </MenuItem>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <Box position="relative">
          <Button
            ref={buttonRef}
            onClick={popover.onToggle}
            // color="primary"
            size={smDown ? 'medium' : 'large'}
            variant="contained"
            startIcon={<Iconify size={30} icon="material-symbols:filter-alt-sharp" />}
            sx={{
              marginTop: '3px',
              '@media (max-width: 1200px)': {
                // Media query for small screens
                display: 'none', // Adjust width on small screens
              },
            }}
          >
            Filter By
          </Button>
          {popover.value && (
            <Portal>
              <Fade in={popover.onTrue}>
                <StyledMenu
                  ref={menuRef}
                  sx={{
                    display: 'flex',
                    maxWidth: '500px',
                    margin: '0px',
                    position: 'absolute',
                    top: buttonRef.current.getBoundingClientRect().bottom + window.scrollY + 10, // 10px gap
                    left: buttonRef.current.getBoundingClientRect().left,
                    '@media (max-width: 1200px)': {
                      // Media query for small screens
                      display: 'none', // Adjust width on small screens
                    },
                  }}
                >
                  {/* Add close icon in the top-right corner */}
                  <Iconify
                    icon="material-symbols:close"
                    onClick={popover.onFalse}
                    sx={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      color: '#212b36',
                      cursor: 'pointer',
                      zIndex: 1,
                      padding: '4px',
                      borderRadius: '50%',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  />

                  <Box
                    gap={2}
                    display="grid"
                    gridTemplateColumns={{
                      xs: 'repeat(1, 1fr)',
                      lg: 'repeat(1, 1fr)',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        position: 'relative',
                        borderRadius: '10px',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                        width: '100%',
                        '@media (max-width: 1200px)': {
                          // Media query for small screens
                          display: 'none', // Adjust width on small screens
                        },
                      }}
                    >
                      <Box
                        sx={{
                          background: '#212b36',
                          display: 'flex',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                          borderTopLeftRadius: '10px',
                          borderBottomLeftRadius: '10px',
                          width: '70px',
                        }}
                      >
                        <Typography color="white">Min</Typography>
                        {/* <Iconify style={{ color: 'white' }} icon="ph:sliders-duotone" /> */}
                      </Box>
                      <TextField
                        value={min}
                        onChange={(e) => setMin(e.target.value)}
                        type="number"
                        placeholder="Min Price"
                        sx={{
                          height: '100%',
                          paddingRight: '15px',
                          width: '100%',
                          background: 'white',
                          borderTopRightRadius: '10px',
                          borderBottomRightRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { border: 'none' },
                            '&:hover fieldset': { border: 'none' },
                            '&.Mui-focused fieldset': { border: 'none' },
                          },
                        }}
                      />
                      {min != '' && (
                        <Iconify
                          onClick={() => {
                            setMin('');
                            // handleSubmit('', max);
                          }}
                          icon="material-symbols:close"
                          style={{
                            position: 'absolute',
                            top: '16px',
                            right: '10px',
                            color: '#9ea392',
                            cursor: 'pointer',
                            cursor: 'pointer',
                          }}
                        />
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        position: 'relative',
                        borderRadius: '10px',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                        '@media (max-width: 1200px)': {
                          // Media query for small screens
                          display: 'none', // Adjust width on small screens
                        },
                      }}
                    >
                      <Box
                        sx={{
                          background: '#212b36',
                          display: 'flex',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                          borderTopLeftRadius: '10px',
                          borderBottomLeftRadius: '10px',
                          width: '60px',
                        }}
                      >
                        <Typography color="white">Max</Typography>
                        {/* <Iconify style={{ color: 'white' }} icon="ph:sliders-duotone" /> */}
                      </Box>
                      <TextField
                        value={max}
                        onChange={(e) => setMax(e.target.value)}
                        type="number"
                        placeholder="Max Price"
                        sx={{
                          height: '100%',
                          width: '400px',
                          background: 'white',
                          borderTopRightRadius: '10px',
                          borderBottomRightRadius: '10px',
                          paddingRight: '15px',
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { border: 'none' },
                            '&:hover fieldset': { border: 'none' },
                            '&.Mui-focused fieldset': { border: 'none' },
                          },
                        }}
                      />
                      {max != '' && (
                        <Iconify
                          onClick={() => {
                            setMax('');
                            // handleSubmit(min, '');
                          }}
                          icon="material-symbols:close"
                          style={{
                            position: 'absolute',
                            top: '16px',
                            right: '10px',
                            color: '#9ea392',
                            cursor: 'pointer',
                          }}
                        />
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        position: 'relative',
                        borderRadius: '10px',
                        height: '3.2em',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                        '@media (max-width: 1200px)': {
                          // Media query for small screens
                          display: 'none', // Adjust width on small screens
                        },
                      }}
                    >
                      <Box
                        sx={{
                          background: '#212b36',
                          display: 'flex',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                          borderTopLeftRadius: '10px',
                          borderBottomLeftRadius: '10px',
                          width: '70px',

                          color: 'white',
                        }}
                      >
                        {/* <Iconify style={{ color: 'white' }} icon="tabler:location-filled" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.4 3.4 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.4 3.4 0 0 0 15 11a3.5 3.5 0 0 0 0-7"
                          />
                        </svg>
                      </Box>
                      <TextField
                        size="small"
                        select
                        fullWidth
                        value={userName}
                        disabled={officeType !== 'Select Office Name'}
                        onChange={(e) => setUserName(e.target.value)}
                        className={userName === 'Select User Name' ? 'select-placeholder' : ''}
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          borderTopRightRadius: '10px',
                          borderBottomRightRadius: '10px',
                          background: 'white',
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              border: 'none', // No border normally
                            },
                            '&.Mui-focused fieldset': {
                              border: 'none', // No border on focus
                            },
                          },
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxHeight: 220,
                                textTransform: 'capitalize',
                              },
                            },
                          },
                          sx: { textTransform: 'capitalize' },
                        }}
                        InputProps={{
                          endAdornment: userName !== 'Select User Name' && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={() => setUserName('Select User Name')}
                                edge="end"
                                sx={{mr: 2}}
                              >
                                <Iconify icon='mdi:close' />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      >
                        <MenuItem value="Select User Name" disabled>
                          Select User Name
                        </MenuItem>
                        {salesRepsInCompany.map((option) => (
                          <MenuItem key={option} value={option?.userName}>
                            {/* <Checkbox
                          disableRipple
                          size="small"
                          checked={filters.role.includes(option?.userName)}
                        /> */}
                            {option?.userName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        position: 'relative',
                        borderRadius: '10px',
                        height: '3.2em',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                        '@media (max-width: 1200px)': {
                          // Media query for small screens
                          display: 'none', // Adjust width on small screens
                        },
                      }}
                    >
                      <Box
                        sx={{
                          background: '#212b36',
                          display: 'flex',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                          borderTopLeftRadius: '10px',
                          borderBottomLeftRadius: '10px',
                          width: '70px',

                          color: 'white',
                        }}
                      >
                        {/* <Iconify style={{ color: 'white' }} icon="tabler:location-filled" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M3 22q-.425 0-.712-.288T2 21v-8q0-.425.288-.712T3 12h3V8q0-2.5 1.75-4.25T12 2h4q2.5 0 4.25 1.75T22 8v14h-2v-3h-4v2q0 .425-.288.713T15 22zm6-3.4l5-2.85V14l-5 2.85L4 14v1.75zm7-1.6h4V8q0-1.65-1.175-2.825T16 4h-4q-1.65 0-2.825 1.175T8 8v4h7q.425 0 .713.288T16 13zm-6-7V8h8v2z"
                          />
                        </svg>
                      </Box>
                      <TextField
                        size="small"
                        select
                        fullWidth
                        value={officeType}
                        disabled={userName !== 'Select User Name'}
                        onChange={(e) => setOfficeType(e.target.value)}
                        className={officeType === 'Select Office Name' ? 'select-placeholder' : ''}
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          borderTopRightRadius: '10px',
                          borderBottomRightRadius: '10px',
                          background: 'white',
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              border: 'none', // No border normally
                            },
                            '&.Mui-focused fieldset': {
                              border: 'none', // No border on focus
                            },
                          },
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxHeight: 220,
                                textTransform: 'capitalize',
                              },
                            },
                          },
                          sx: { textTransform: 'capitalize' },
                        }}
                        InputProps={{
                          endAdornment: officeType !== 'Select Office Name' && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={() => setOfficeType('Select Office Name')}
                                edge="end"
                                sx={{mr: 2}}
                              >
                                <Iconify icon='mdi:close' />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      >
                        <MenuItem value="Select Office Name" disabled>
                          Select Office Name
                        </MenuItem>
                        {offices.length > 0 &&
                          offices.map((option) => (
                            <MenuItem key={option.name} value={option?.name}>
                              {/* <Checkbox
                          disableRipple
                          size="small"
                          checked={filters.role.includes(option?.userName)}
                        /> */}
                              {option?.name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        borderRadius: '10px',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                        '@media (max-width: 1200px)': {
                          display: 'none', // Hide on small screens
                        },
                      }}
                      mb={rangeType != 'Custom' ? 2 : 0}
                    >
                      <Box
                        sx={{
                          background: '#212b36',
                          display: 'flex',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                          borderTopLeftRadius: '10px',
                          borderBottomLeftRadius: '10px',
                          width: '70px',
                          color: 'white',
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M8 14q-.425 0-.712-.288T7 13t.288-.712T8 12t.713.288T9 13t-.288.713T8 14m4 0q-.425 0-.712-.288T11 13t.288-.712T12 12t.713.288T13 13t-.288.713T12 14m4 0q-.425 0-.712-.288T15 13t.288-.712T16 12t.713.288T17 13t-.288.713T16 14M5 22q-.825 0-1.412-.587T3 20V6q0-.825.588-1.412T5 4h1V3q0-.425.288-.712T7 2t.713.288T8 3v1h8V3q0-.425.288-.712T17 2t.713.288T18 3v1h1q.825 0 1.413.588T21 6v14q0 .825-.587 1.413T19 22zm0-2h14V10H5zM5 8h14V6H5zm0 0V6z"
                          />
                        </svg>
                      </Box>

                      <TextField
                        select
                        fullWidth
                        value={rangeType}
                        className={rangeType === 'Select Date Range' ? 'select-placeholder' : ''}
                        onChange={(e) => {
                          if (e.target.value != 'custom') {
                            setStartDate(null);
                            setEndDate(null);
                          }
                          setRangeType(e.target.value);
                        }}
                        sx={{
                          width: '100%',
                          borderTopRightRadius: '10px',
                          borderBottomRightRadius: '10px',
                          background: 'white',
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { border: 'none' },
                            '&.Mui-focused fieldset': { border: 'none' },
                          },
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxHeight: 220,
                                textTransform: 'capitalize',
                              },
                            },
                          },
                          sx: { textTransform: 'capitalize' },
                        }}
                      >
                        <MenuItem value="Select Date Range">Select Date Range</MenuItem>
                        {[
                          { label: 'Past 30 days', value: 'last30days' },
                          { label: 'Past Year', value: 'lastYear' },
                          { label: 'Past 5 Years', value: 'last5Years' },
                          { label: 'Custom', value: 'custom' },
                        ].map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>

                    {rangeType === 'custom' && (
                      <Box
                        mb={2}
                        gap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(2, 1fr)',
                          lg: 'repeat(2, 1fr)',
                        }}
                      >
                        <DatePicker
                          value={startDate}
                          onChange={(e) => setStartDate(e)}
                          sx={{
                            borderRadius: '10px',
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                          }}
                          label="Start date"
                          slotProps={{
                            textField: { fullWidth: true },
                          }}
                        />
                        <DatePicker
                          value={endDate}
                          onChange={(e) => setEndDate(e)}
                          sx={{
                            borderRadius: '10px',
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                          }}
                          label="End date"
                          slotProps={{
                            textField: { fullWidth: true },
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                </StyledMenu>
              </Fade>
            </Portal>
          )}
        </Box>

        <LoadingButton
          loading={loading}
          onClick={() => {
            handleSubmit(min, max);
          }}
          sx={{
            width: '150px',
            marginTop: '3px',
            '@media (max-width: 1500px)': {
              // Media query for small screens
              width: '120px', // Adjust width on small screens
            },
            '@media (max-width: 1200px)': {
              // Media query for small screens
              display: 'none', // Adjust width on small screens
            },
          }}
          // color="primary"
          size="large"
          type="submit"
          variant="contained"
          startIcon={<Iconify icon="material-symbols:search" />}
        >
          Search
        </LoadingButton>
        <Tooltip title="Reset">
          <LoadingButton
            loading={resetLoading}
            onClick={() => {
              setPositions({});
              setRadius('Select Distance');
              setFormattedAddress('');
              setMax('');
              setMin('');
              resetLocationData();
              setresetLoading(true);
              setRangeType('Select Date Range');
              setStartDate(null);
              setEndDate(null);
              handleSubmit('', '', true);
            }}
            // color="primary"
            size="large"
            variant="contained"
            sx={{
              marginTop: '3px',
              '@media (max-width: 1200px)': {
                // Media query for small screens
                display: 'none', // Adjust width on small screens
              },
            }}
          >
            <Iconify icon="material-symbols:refresh" />
          </LoadingButton>
        </Tooltip>
        <Box
          sx={{
            display: {
              xs: 'none',
              sm: 'flex',
              lg: 'flex',
              md: 'flex',
            },
            gap: 1,
          }}
        >
          <ToggleSwitch IsHeatMap={IsHeatMap} setIsHeatMap={setIsHeatMap} />
          {/* <ToggleSwitchFilterJobs myJobs={myJobs} setMyJobs={setMyJobs} /> */}
        </Box>
        <Box>
          <Button
            onClick={() => nav.onToggle()}
            // color="primary"
            size={smDown ? 'medium' : 'large'}
            variant="contained"
            sx={{
              marginTop: '3px',
              '@media (min-width: 1200px)': {
                // Media query for small screens
                display: 'none', // Adjust width on small screens
              },
            }}
          >
            <Iconify size={30} icon="material-symbols:filter-alt-sharp" />
          </Button>
          {/* <Tooltip title="List View"> */}
          <Button
            onClick={() => {
              nav.onFalse();
              toggleVisibility();
            }}
            // color="primary"
            size={smDown ? 'medium' : 'large'}
            variant="contained"
            sx={{ marginTop: '3px', marginLeft: '10px' }}
          >
            <Iconify icon="ic:outline-menu" />
          </Button>
          {/* </Tooltip> */}
        </Box>
      </Box>

      {/* for mobile view filters */}
      {nav.value && (
        <Portal>
          <Fade in={nav.onTrue}>
            <StyledMenu
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: '500px',
                top: '70px',
                margin: '0px',
                left: '20px',
                right: '20px',

                '@media (min-width: 1200px)': {
                  // Media query for small screens
                  display: 'none', // Adjust width on small screens
                },
              }}
            >
              <Iconify
                icon="material-symbols:close"
                onClick={nav.onFalse}
                sx={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  color: '#212b36',
                  cursor: 'pointer',
                  zIndex: 1,
                  padding: '4px',
                  borderRadius: '50%',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              />
              <Box
                sx={{
                  margin: '0px 10px 30px',
                  // textAlign: 'center',
                  // justifyContent: 'center',
                  width: '100%',
                  // flexWrap: { xs: 'wrap', md: 'wrap', lg: 'nowrap' }
                }}
                gap={3}
                // display="flex"
              >
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    width: '100%',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                    borderRadius: '10px',
                  }}
                >
                  <Box
                    sx={{
                      background: '#212b36',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      width: '60px',
                    }}
                  >
                    <Iconify style={{ color: 'white' }} icon="gis:location-poi" />
                  </Box>
                  <Autocomplete
                    className="mainContainerAutoComplete2"
                    onLoad={onLoadAutocomplete}
                    onPlaceChanged={onPlaceChanged}
                  >
                    <TextField
                      value={formattedAddress}
                      onChange={(e) => setFormattedAddress(e.target.value)}
                      placeholder="Enter a location"
                      size="small"
                      sx={{
                        paddingRight: '15px',
                        height: '100%',
                        width: '100%',
                        paddingRight: '15px',
                        background: 'white',
                        borderTopRightRadius: '10px',
                        borderBottomRightRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': { border: 'none' },
                          '&:hover fieldset': { border: 'none' },
                          '&.Mui-focused fieldset': { border: 'none' },
                        },
                      }}
                    />
                  </Autocomplete>
                  {formattedAddress != '' && (
                    <Iconify
                      onClick={() => {
                        setFormattedAddress('');
                      }}
                      icon="material-symbols:close"
                      style={{
                        position: 'absolute',
                        top: '9px',
                        right: '10px',
                        color: '#9ea392',
                        cursor: 'pointer',
                        cursor: 'pointer',
                      }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    marginTop: '10px',
                    width: '100%',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                    borderRadius: '10px',
                  }}
                >
                  <Box
                    sx={{
                      background: '#212b36',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      width: '60px',

                      color: 'white',
                    }}
                  >
                    {/* <Iconify style={{ color: 'white' }} icon="tabler:location-filled" /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.03 6.03 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8"
                      />
                    </svg>
                  </Box>
                  <TextField
                    size="small"
                    select
                    fullWidth
                    value={radius}
                    onChange={(e) => setRadius(e.target.value)}
                    className={radius == 'Select Distance' ? 'select-placeholder' : ''}
                    sx={{
                      width: '100%',
                      borderTopRightRadius: '10px',
                      borderBottomRightRadius: '10px',
                      background: 'white',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          border: 'none', // No border normally
                        },
                        '&.Mui-focused fieldset': {
                          border: 'none', // No border on focus
                        },
                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 220,
                            textTransform: 'capitalize',
                          },
                        },
                      },
                      sx: { textTransform: 'capitalize' },
                    }}
                  >
                    <MenuItem value="Select Distance" disabled>
                      Select Distance
                    </MenuItem>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    marginTop: '10px',
                    width: '100%',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                    borderRadius: '10px',
                  }}
                >
                  <Box
                    sx={{
                      background: '#212b36',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      width: '60px',

                      color: 'white',
                    }}
                  >
                    {/* <Iconify style={{ color: 'white' }} icon="tabler:location-filled" /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.4 3.4 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.4 3.4 0 0 0 15 11a3.5 3.5 0 0 0 0-7"
                      />
                    </svg>
                  </Box>
                  <TextField
                    size="small"
                    select
                    fullWidth
                    value={userName}
                    disabled={officeType !== 'Select Office Name'}
                    onChange={(e) => setUserName(e.target.value)}
                    className={userName === 'Select User Name' ? 'select-placeholder' : ''}
                    sx={{
                      width: '100%',
                      borderTopRightRadius: '10px',
                      borderBottomRightRadius: '10px',
                      background: 'white',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          border: 'none', // No border normally
                        },
                        '&.Mui-focused fieldset': {
                          border: 'none', // No border on focus
                        },
                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 220,
                            textTransform: 'capitalize',
                          },
                        },
                      },
                      sx: { textTransform: 'capitalize' },
                    }}
                    InputProps={{
                      endAdornment: userName !== 'Select User Name' && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setUserName('Select User Name')}
                            edge="end"
                            sx={{mr: 2}}
                          >
                            <Iconify icon='mdi:close' />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  >
                    <MenuItem value="Select User Name" disabled>
                      Select User Name
                    </MenuItem>
                    {salesRepsInCompany.map((option) => (
                      <MenuItem key={option} value={option?.userName}>
                        {/* <Checkbox
                          disableRipple
                          size="small"
                          checked={filters.role.includes(option?.userName)}
                        /> */}
                        {option?.userName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    marginTop: '10px',
                    width: '100%',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                    borderRadius: '10px',
                  }}
                >
                  <Box
                    sx={{
                      background: '#212b36',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      width: '60px',

                      color: 'white',
                    }}
                  >
                    {/* <Iconify style={{ color: 'white' }} icon="tabler:location-filled" /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M3 22q-.425 0-.712-.288T2 21v-8q0-.425.288-.712T3 12h3V8q0-2.5 1.75-4.25T12 2h4q2.5 0 4.25 1.75T22 8v14h-2v-3h-4v2q0 .425-.288.713T15 22zm6-3.4l5-2.85V14l-5 2.85L4 14v1.75zm7-1.6h4V8q0-1.65-1.175-2.825T16 4h-4q-1.65 0-2.825 1.175T8 8v4h7q.425 0 .713.288T16 13zm-6-7V8h8v2z"
                      />
                    </svg>
                  </Box>
                  <TextField
                    size="small"
                    select
                    fullWidth
                    value={officeType}
                    disabled={userName !== 'Select User Name'}
                    onChange={(e) => setOfficeType(e.target.value)}
                    className={officeType === 'Select Office Name' ? 'select-placeholder' : ''}
                    sx={{
                      width: '100%',
                      borderTopRightRadius: '10px',
                      borderBottomRightRadius: '10px',
                      background: 'white',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          border: 'none', // No border normally
                        },
                        '&.Mui-focused fieldset': {
                          border: 'none', // No border on focus
                        },
                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 220,
                            textTransform: 'capitalize',
                          },
                        },
                      },
                      sx: { textTransform: 'capitalize' },
                    }}
                    InputProps={{
                      endAdornment: officeType !== 'Select Office Name' && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setOfficeType('Select Office Name')}
                            edge="end"
                            sx={{mr: 2}}
                          >
                            <Iconify icon='mdi:close' />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  >
                    <MenuItem value="Select Office Name" disabled>
                      Select Office Name
                    </MenuItem>
                    {offices.length > 0 &&
                      offices.map((option) => (
                        <MenuItem key={option.name} value={option?.name}>
                          {/* <Checkbox
                          disableRipple
                          size="small"
                          checked={filters.role.includes(option?.userName)}
                        /> */}
                          {option?.name}
                        </MenuItem>
                      ))}
                  </TextField>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    position: 'relative',
                    marginTop: '10px',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                    borderRadius: '10px',
                  }}
                >
                  <Box
                    sx={{
                      background: '#212b36',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      width: '60px',
                    }}
                  >
                    <Typography color="white">Min</Typography>
                    {/* <Iconify style={{ color: 'white' }} icon="ph:sliders-duotone" /> */}
                  </Box>
                  <TextField
                    value={min}
                    onChange={(e) => setMin(e.target.value)}
                    type="number"
                    placeholder="Min Price"
                    size="small"
                    sx={{
                      height: '100%',
                      width: '100%',
                      background: 'white',
                      borderTopRightRadius: '10px',
                      borderBottomRightRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { border: 'none' },
                        '&:hover fieldset': { border: 'none' },
                        '&.Mui-focused fieldset': { border: 'none' },
                      },
                    }}
                  />
                  {min != '' && (
                    <Iconify
                      onClick={() => {
                        setMin('');
                        // handleSubmit('', max);
                      }}
                      icon="material-symbols:close"
                      style={{
                        position: 'absolute',
                        top: '9px',
                        right: '10px',
                        color: '#9ea392',
                        cursor: 'pointer',
                        cursor: 'pointer',
                      }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    position: 'relative',
                    marginTop: '10px',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                    borderRadius: '10px',
                  }}
                >
                  <Box
                    sx={{
                      background: '#212b36',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      borderTopLeftRadius: '10px',
                      width: '60px',
                      borderBottomLeftRadius: '10px',
                    }}
                  >
                    <Typography color="white">Max</Typography>
                    {/* <Iconify style={{ color: 'white' }} icon="ph:sliders-duotone" /> */}
                  </Box>
                  <TextField
                    value={max}
                    onChange={(e) => setMax(e.target.value)}
                    type="number"
                    size="small"
                    placeholder="Max Price"
                    sx={{
                      height: '100%',
                      width: '100%',
                      background: 'white',
                      borderTopRightRadius: '10px',
                      borderBottomRightRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { border: 'none' },
                        '&:hover fieldset': { border: 'none' },
                        '&.Mui-focused fieldset': { border: 'none' },
                      },
                    }}
                  />
                  {max != '' && (
                    <Iconify
                      onClick={() => {
                        setMax('');
                        // handleSubmit(min, '');
                      }}
                      icon="material-symbols:close"
                      style={{
                        position: 'absolute',
                        top: '9px',
                        right: '10px',
                        color: '#9ea392',
                        cursor: 'pointer',
                      }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    borderRadius: '10px',
                    marginTop: '10px',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                  }}
                >
                  <Box
                    sx={{
                      background: '#212b36',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      width: '60px',
                      color: 'white',
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M8 14q-.425 0-.712-.288T7 13t.288-.712T8 12t.713.288T9 13t-.288.713T8 14m4 0q-.425 0-.712-.288T11 13t.288-.712T12 12t.713.288T13 13t-.288.713T12 14m4 0q-.425 0-.712-.288T15 13t.288-.712T16 12t.713.288T17 13t-.288.713T16 14M5 22q-.825 0-1.412-.587T3 20V6q0-.825.588-1.412T5 4h1V3q0-.425.288-.712T7 2t.713.288T8 3v1h8V3q0-.425.288-.712T17 2t.713.288T18 3v1h1q.825 0 1.413.588T21 6v14q0 .825-.587 1.413T19 22zm0-2h14V10H5zM5 8h14V6H5zm0 0V6z"
                      />
                    </svg>
                  </Box>

                  <TextField
                    size="small"
                    select
                    fullWidth
                    value={rangeType}
                    className={rangeType === 'Select Date Range' ? 'select-placeholder' : ''}
                    onChange={(e) => {
                      if (e.target.value != 'custom') {
                        setStartDate(null);
                        setEndDate(null);
                      }
                      setRangeType(e.target.value);
                    }}
                    sx={{
                      width: '100%',
                      borderTopRightRadius: '10px',
                      borderBottomRightRadius: '10px',
                      background: 'white',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { border: 'none' },
                        '&.Mui-focused fieldset': { border: 'none' },
                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 220,
                            textTransform: 'capitalize',
                          },
                        },
                      },
                      sx: { textTransform: 'capitalize' },
                    }}
                  >
                    <MenuItem value="Select Date Range">Select Date Range</MenuItem>
                    {[
                      { label: 'Past 30 days', value: 'last30days' },
                      { label: 'Past Year', value: 'lastYear' },
                      { label: 'Past 5 Years', value: 'last5Years' },
                      { label: 'Custom', value: 'custom' },
                    ].map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>

                {rangeType === 'custom' && (
                  <Box
                    gap={2}
                    display="grid"
                    gridTemplateColumns={{
                      xs: 'repeat(1, 1fr)',
                      lg: 'repeat(1, 1fr)',
                    }}
                  >
                    <DatePicker
                      value={startDate}
                      onChange={(e) => setStartDate(e)}
                      sx={{
                        marginTop: '10px',
                        borderRadius: '10px',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                      }}
                      label="Start date"
                      slotProps={{
                        textField: { fullWidth: true, size: 'small' },
                      }}
                    />
                    <DatePicker
                      value={endDate}
                      onChange={(e) => setEndDate(e)}
                      sx={{
                        borderRadius: '10px',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                      }}
                      label="End date"
                      slotProps={{
                        textField: { fullWidth: true, size: 'small' },
                      }}
                    />
                  </Box>
                )}
                <Box display="flex" gap={2}>
                  <LoadingButton
                    loading={loading}
                    onClick={() => {
                      handleSubmit(min, max);
                    }}
                    sx={{ width: '100%', marginTop: '3px', marginTop: '10px' }}
                    // color="primary"
                    size="medium"
                    type="submit"
                    variant="contained"
                    startIcon={<Iconify icon="material-symbols:search" />}
                  >
                    Search
                  </LoadingButton>
                  <Tooltip title="Reset">
                    <LoadingButton
                      size="medium"
                      loading={resetLoading}
                      onClick={() => {
                        setPositions({});
                        setRadius('Select Distance');
                        setFormattedAddress('');
                        setMax('');
                        setMin('');
                        resetLocationData();
                        setresetLoading(true);
                        setRangeType('Select Date Range');
                        setStartDate(null);
                        setEndDate(null);
                        handleSubmit('', '', true);
                      }}
                      // color="primary"
                      variant="contained"
                      sx={{ marginTop: '10px' }}
                    >
                      <Iconify icon="material-symbols:refresh" />
                    </LoadingButton>
                  </Tooltip>
                </Box>
              </Box>
            </StyledMenu>
          </Fade>
        </Portal>
      )}
    </>
  );
}
